"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.relayerFeeEnabled = exports.destinationFeeGasPriceMultiplier = exports.bonderFeeBps = exports.bonders = exports.chains = exports.addresses = void 0;
const addresses_1 = require("@hop-protocol/core/addresses");
const config_1 = require("@hop-protocol/core/config");
const networks_1 = require("@hop-protocol/core/networks");
const chains = {};
exports.chains = chains;
for (const chain in networks_1.kovan) {
    const network = networks_1.kovan[chain];
    if (!chains[chain]) {
        chains[chain] = {};
    }
    chains[chain].name = network === null || network === void 0 ? void 0 : network.name;
    chains[chain].chainId = network === null || network === void 0 ? void 0 : network.networkId;
    chains[chain].rpcUrl = network === null || network === void 0 ? void 0 : network.publicRpcUrl;
    chains[chain].explorerUrl = (_a = network === null || network === void 0 ? void 0 : network.explorerUrls) === null || _a === void 0 ? void 0 : _a[0];
    chains[chain].waitConfirmations = (_b = network === null || network === void 0 ? void 0 : network.waitConfirmations) !== null && _b !== void 0 ? _b : 1;
    chains[chain].hasFinalizationBlockTag = network === null || network === void 0 ? void 0 : network.hasFinalizationBlockTag;
    chains[chain].subgraphUrl = network === null || network === void 0 ? void 0 : network.subgraphUrl;
}
const addresses = addresses_1.kovan.bridges;
exports.addresses = addresses;
const bonders = addresses_1.kovan.bonders;
exports.bonders = bonders;
const bonderFeeBps = config_1.kovan.bonderFeeBps;
exports.bonderFeeBps = bonderFeeBps;
const destinationFeeGasPriceMultiplier = config_1.kovan.destinationFeeGasPriceMultiplier;
exports.destinationFeeGasPriceMultiplier = destinationFeeGasPriceMultiplier;
const relayerFeeEnabled = config_1.kovan.relayerFeeEnabled;
exports.relayerFeeEnabled = relayerFeeEnabled;
